import { RESPONSE_TYPES } from "@constants/response-types";
import { HttpService } from "@services/http";
import {
  prepareErrorResponse,
  prepareResponseObject,
} from "@services/http/response";

export class ContactUsService extends HttpService {
  contactUs = async (
    baseAuthUrl: string,
    data: FormData
  ): Promise<TObject> => {
    try {
      const headers: TObject = {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      };
      const apiResponse = await this.post(
        `${baseAuthUrl}/api/contact-us`,
        data,
        {headers}
      );
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
}
